import { Directive, ViewContainerRef } from '@angular/core';
@Directive({
  selector: '[appGridRegistrationForm]'
})
export class GridRegistrationFormDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
